import { Injectable } from '@angular/core';
import {
  CriteriaProductExclusions,
  CriteriaVehicleBodyStyles,
  CriteriaVehicleMakes,
  CriteriaVehicleModels,
  CriteriaVehicleYears,
} from '@wb/core/interfaces/criteria';
import { Mutation } from 'apollo-angular';
import gql from 'graphql-tag';

export interface UpdateCriteriaResponse {
  updateCriteria: {
    code: string;
    success: boolean;
  };
}

export interface UpdateCriteriaInput {
  accessoryUid?: String;
  feeUid?: String;
  fiAddOnUid?: String;
  bodyStyleUid?: String;
  operator?: string;
  for_vehicle?: string;
  for_product?: string;
  vehicle_condition?: string;
  deal_type?: string;
  origin?: string;
  type?: string;
  city?: string;
  county?: string;
  state?: string;
  fuel_type?: string;
  input_name?: string;
  input_name_normalized?: string;
  vehicleBodyStyles?: CriteriaVehicleBodyStyles[];
  vehicleMakes?: CriteriaVehicleMakes[];
  vehicleModels?: CriteriaVehicleModels[];
  vehicleYears?: CriteriaVehicleYears[];
  productExclusions?: CriteriaProductExclusions[];
}

export interface UpdateCriteriaParams {
  uid: string;
  input: UpdateCriteriaInput;
}

@Injectable({
  providedIn: 'root',
})
export class UpdateCriteriaGQL extends Mutation<UpdateCriteriaResponse, UpdateCriteriaParams> {
  document = gql(`
    mutation updateCriteria ($uid: ID!, $input: ModelCriteriaUpdateInput) {
      updateCriteria (uid: $uid, input: $input) {
        code
        success
      }
    }
  `);
}

export interface CreateCriteriaResponse {
  createCriteria: {
    code: string;
    success: boolean;
    criteria: {
      uid: string;
    };
  };
}

export interface InsertCriteriaInput extends UpdateCriteriaInput {
  accountUid: string;
}

export interface CreateCriteriaParams {
  input: InsertCriteriaInput;
}

@Injectable({
  providedIn: 'root',
})
export class CreateCriteriaGQL extends Mutation<CreateCriteriaResponse, CreateCriteriaParams> {
  document = gql(`
    mutation createCriteria ($input: ModelCriteriaInsertInput) {
      createCriteria (input: $input) {
        code
        success
        criteria {
          uid
        }
      }
    }
  `);
}

export interface DeleteCriteriaResponse {
  deleteCriteria: {
    code: string;
    success: boolean;
  };
}

export interface DeleteCriteriaParams {
  uid: string;
}

@Injectable({
  providedIn: 'root',
})
export class DeleteCriteriaGQL extends Mutation<DeleteCriteriaResponse, DeleteCriteriaParams> {
  document = gql(`
    mutation deleteCriteria ($uid: ID!) {
      deleteCriteria (uid: $uid) {
        code
        success
      }
    }
  `);
}
